const actionTypeIdentifier = 'DD7F53BC-691A-40F6-B279-EC1188FFA821';

export const getAdminSetting = `GET-ADMIN-SETTING-${actionTypeIdentifier}`;
export const setDateFormat = `SET-ADMIN-SETTING-DATE-FORMAT-${actionTypeIdentifier}`;